module.exports = __webpack_public_path__ + "static/media/ic_exc_orange.7716218d.png";